import { createBrowserRouter, Navigate } from 'react-router';
import RootLayout from './RootLayout';
import ErrorPage from './ErrorPage';
import PublicLayout from './PublicLayout';
import PublicDocsLayout from './PublicDocsLayout';
import ProtectedLayout from './ProtectedLayout';
import Login from '../components/Login';
import { Signup } from '../components/auth/Signup';
import { ForgotPassword } from '../components/auth/ForgotPassword';
import { ResetPassword } from '../components/auth/ResetPassword';
import { UpdatePassword } from '../components/auth/UpdatePassword';
import { OtpVerification } from '../components/auth/OtpVerification';
import Dashboard from '../components/Dashboard';
import Profile from '../components/Profile';
import { DocsPage } from '../components/docs/DocsPage';
import { PublicApiOverview } from '../components/docs/PublicApiOverview';
import { Analytics } from '../components/Analytics';
import { CompanyList } from '../components/CompanyList';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to="/login" replace />,
      },
      // Public routes with layout
      {
        Component: PublicLayout,
        children: [
          { path: 'login', Component: Login },
          { path: 'signup', Component: Signup },
          { path: 'forgot-password', Component: ForgotPassword },
          { path: 'resetpassword', Component: ResetPassword },
          { path: 'otp-verification', Component: OtpVerification },
        ],
      },
      // Public docs route without authentication logic
      {
        Component: PublicDocsLayout,
        children: [
          { path: 'api-docs', Component: PublicApiOverview },
        ],
      },
      // Protected routes with layout
      {
        Component: ProtectedLayout,
        children: [
          // Redirect docs to API Overview
          { 
            path: 'docs', 
            element: <Navigate to="/api-reference/introduction" replace />
          },
          // Redirect api-reference root to API Overview
          { 
            path: 'api-reference', 
            element: <Navigate to="/api-reference/introduction" replace />
          },
          { 
            path: 'api-reference/*', 
            Component: DocsPage,
          },
          { path: 'analytics', Component: Analytics },
          { path: 'companies', Component: CompanyList },
          { path: 'dashboard', Component: Dashboard },
          { path: 'profile', Component: Profile },
          { path: 'update-password', Component: UpdatePassword },
        ],
      },
    ],
  },
]);
